export default __webpack_public_path__ + "static/media/account_circle_black_48dp.f70f56f4.svg";